async function getContextData(handle){
    
    const response = await fetch(window.Shopify.routes.root + `products/${handle}?view=context`, {

        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      return data;
}

async function getSectionTemplate(id, handle){
    const response = await fetch(window.Shopify.routes.root + `products/${handle}?id=${id}&sections=pdp-product-minimal`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      return data; 
}

async function getProduct(handle){
    const response = await fetch(window.Shopify.routes.root + `products/${handle}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      return data; 
}


const container = document.querySelector('div[data-snippet-type="modal"]');

// Initialize a new instance of MutationObserver
const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
        // Check if new nodes are added
        if (mutation.type === 'childList') {
            for (let addedNode of mutation.addedNodes) {
                // Here, you can perform actions on the newly added nodes
                
                console.log('added child');
                let documentSection = document.querySelector('div[data-snippet-type="modal"] div[data-snippet-type="pdp-product-form"] script[data-context]').textContent;
                
                


                
                //let documentSection = JSON.parse($('div[data-snippet-type="modal"] script#product_info').textContent);
                 window.currentPdpProduct = JSON.parse(documentSection);

                // If you want to observe the intersection of the newly added node
                const intersectionObserver = new IntersectionObserver((entries) => {
                    for (let entry of entries) {
                        if (entry.isIntersecting) {
                            console.log('Node is now visible!', entry.target);
                        }
                    }
                });
                intersectionObserver.observe(addedNode);
            }
        }
    }
});

// Configuration for the observer
const config = {
    childList: true, // Observe when child elements are added or removed
};

// Start observing the container
observer.observe(container, config);



var mouseState = true;


function openQuickView(){
    let id = window?.currentPdpProduct?.pid;
    let elemn = $('button.pdp-product-buttons__view[data-snippet-pid='+id+']').find('section.shopify-section:first');
    $('main div[data-snippet-type="modal"]').attr('data-pid',id).html(elemn).addClass('active showing'); 
}




$(document).on('click','.active_frequency', function(){

    $(this).parent().toggleClass('active');
});
$(document).on('change', 'input[name="purchase_type"]', function() {
    $('label.pdp-product-form__recharge__purchase-type').removeClass('active');
    if ($(this).val() == 'onetime') {
    $('#custom-purchase-type').text('PURCHASE: ONE-TIME')
    $('label.pdp-product-form__recharge__purchase-type--onetime').addClass('active')
    $('.frequency_box').removeClass('active');
    $('#subscription_recharge_pdp').parent().siblings('.point_box').removeClass('active');
    if(!window.hasSubItem){
      $('.no_sub_onetime').css('display', 'block');
      $('.default_truemed').css('display', 'none');
      window.renderTrueMed('tm_qual_4u1d2nuk59'); 
    }else{
      $('.no_sub_onetime').css('display', 'none');
      $('.default_truemed').css('display', 'block'); 
      window.renderTrueMed('tm_qual_xjpnex9saq');
    }
    } else {
    $(this).parent().siblings('.point_box').addClass('active');
    $('#custom-purchase-type').text('PURCHASE: SUBSCRIPTION')
    $('label.pdp-product-form__recharge__purchase-type--autodeliver').addClass('active')
    $('.no_sub_onetime').css('display', 'none');
    $('.default_truemed').css('display', 'block'); 
    window.renderTrueMed('tm_qual_76hhej13na');
    
    }
});

    $(document).on('change', 'input[name="selling_plan"]', function(){
        const chargeInterval = $.trim($(this).siblings('span').children('span.units').text());

        $('label.active_delivery_frequency span').text(chargeInterval);
        $('.frequency_box').removeClass('active');
    });

    $(document).on('click', 'input[name="selling_plan"]', function(){
        $('.frequency_box').removeClass('active'); 
    })


    document.addEventListener('DOMContentLoaded', function() {
        // Map menu buttons to their corresponding mega menus
        const menuMap = {
          'shopping-btn-container': 'shopify-section-mega-menu-shopping',
          'exploring-btn-container': 'shopify-section-mega-menu-exploring'
          // Add more mappings if you have other menu items
        };
      
        // Get all menu items that should trigger mega menus
        const menuItems = document.querySelectorAll('.shopping-btn-container button, .exploring-btn-container button');
        
        // Get all close buttons in mega menus
        const closeButtons = document.querySelectorAll('.mega-close-btn button');
      
        // Function to open a specific mega menu
        function openMenu(menuId) {
          // Close all menus first
          closeAllMenus();
          
          // Open the requested menu
          const menu = document.getElementById(menuId);
          if (menu) {
            menu.classList.add('menu-open');
            
            // Focus the first focusable element in the menu
            const firstFocusable = menu.querySelector('a, button, [tabindex="0"]');
            if (firstFocusable) {
              firstFocusable.focus();
            }
          }
        }
      
        // Function to close all mega menus
        function closeAllMenus() {
          document.querySelectorAll('.mega-menu-wrapper').forEach(menu => {
            menu.classList.remove('menu-open');
          });
        }
      
        // Add event listeners to menu items
        menuItems.forEach(item => {
          // Mouse events
          item.addEventListener('mouseenter', function() {
            const container = this.closest('li');
            if (container && menuMap[container.className]) {
              openMenu(menuMap[container.className]);
            }
          });
      
          // Keyboard events
          item.addEventListener('keydown', function(e) {
            const container = this.closest('li');
            
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if (container && menuMap[container.className]) {
                openMenu(menuMap[container.className]);
              }
            } else if (e.key === 'ArrowDown') {
              e.preventDefault();
              if (container && menuMap[container.className]) {
                openMenu(menuMap[container.className]);
              }
            }
          });
        });
      
        // Add event listeners to close buttons
        closeButtons.forEach(button => {
          button.addEventListener('click', closeAllMenus);
          button.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              closeAllMenus();
              
              // Return focus to the corresponding menu button
              const menuWrapper = this.closest('.mega-menu-wrapper');
              if (menuWrapper) {
                const menuId = menuWrapper.id;
                for (const [containerClass, wrapperId] of Object.entries(menuMap)) {
                  if (wrapperId === menuId) {
                    const button = document.querySelector(`.${containerClass} button`);
                    if (button) button.focus();
                    break;
                  }
                }
              }
            }
          });
        });
      
        // Close menu when Escape is pressed
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            closeAllMenus();
            
            // Return focus to the last focused menu button
            const openMenu = document.querySelector('.mega-menu-wrapper.menu-open');
            if (openMenu) {
              const menuId = openMenu.id;
              for (const [containerClass, wrapperId] of Object.entries(menuMap)) {
                if (wrapperId === menuId) {
                  const button = document.querySelector(`.${containerClass} button`);
                  if (button) button.focus();
                  break;
                }
              }
            }
          }
        });
      
        // Close menu when clicking outside
        document.addEventListener('click', function(e) {
          if (!e.target.closest('.mega-menu-wrapper') && !e.target.closest('.shopping-btn-container') && !e.target.closest('.exploring-btn-container')) {
            closeAllMenus();
          }
        });
      });



      // document.addEventListener('DOMContentLoaded', function() {
      //   const frequencyBox = document.querySelector('.frequency_box');
      //   const frequencyItems = document.querySelectorAll('.pdp-product-form__recharge__frequency__buttons li label');
        
      //   // Toggle dropdown on Enter key press
      //   frequencyBox.addEventListener('keydown', function(e) {
      //     if (e.key === 'Enter' || e.key === ' ') {
      //       e.preventDefault();
      //       this.classList.toggle('active');
            
      //       // Focus the first option when opening
      //       if (this.classList.contains('active')) {
      //         const firstOption = this.querySelector('input[type="radio"]');
      //         if (firstOption) firstOption.focus();
      //       }
      //     }
          
      //     // Close on Escape
      //     if (e.key === 'Escape') {
      //       this.classList.remove('active');
      //     }
      //   });
        
      //   // Close dropdown when clicking outside
      //   document.addEventListener('click', function(e) {
      //     if (!frequencyBox.contains(e.target)) {
      //       frequencyBox.classList.remove('active');
      //     }
      //   });
        
      //   // Handle label clicks to simulate radio button selection
      //   frequencyItems.forEach(label => {
      //     label.addEventListener('click', function() {
      //       const radio = this.querySelector('input[type="radio"]');
      //       if (radio) {
      //         radio.checked = true;
              
      //         // Update the displayed selection
      //         const activeLabel = document.querySelector('.active_delivery_frequency span');
      //         const selectedLabel = this.querySelector('.units');
      //         if (activeLabel && selectedLabel) {
      //           activeLabel.textContent = selectedLabel.textContent;
      //         }
              
      //         // Close the dropdown
      //         frequencyBox.classList.remove('active');
      //       }
      //     });
          
      //     // Make labels keyboard accessible
      //     label.addEventListener('keydown', function(e) {
      //       if (e.key === 'Enter' || e.key === ' ') {
      //         e.preventDefault();
      //         this.click();
      //       }
      //     });
      //   });
        
      //   // Add tabindex to labels for keyboard navigation
      //   frequencyItems.forEach(label => {
      //     label.setAttribute('tabindex', '0');
      //   });
      // });